__turbopack_context__.v({
  "bar": "SiteNav-module-scss-module__5TlSfG__bar",
  "hairline": "SiteNav-module-scss-module__5TlSfG__hairline",
  "landing": "SiteNav-module-scss-module__5TlSfG__landing",
  "logoSlot": "SiteNav-module-scss-module__5TlSfG__logoSlot",
  "menuButton": "SiteNav-module-scss-module__5TlSfG__menuButton",
  "panelIn": "SiteNav-module-scss-module__5TlSfG__panelIn",
  "premiumTrigger": "SiteNav-module-scss-module__5TlSfG__premiumTrigger",
  "root": "SiteNav-module-scss-module__5TlSfG__root",
  "tools": "SiteNav-module-scss-module__5TlSfG__tools",
});
